<h2 mat-dialog-title>{{ is_edit_mode ? 'Editar vacante' : 'Nueva vacante' }}</h2>

<mat-dialog-content [formGroup]="form">
  <mat-form-field class="full-width">
    <mat-label>Título</mat-label>
    <input matInput formControlName="title" />
  </mat-form-field>

  <mat-form-field class="full-width">
    <mat-label>URL de la oferta</mat-label>
    <input matInput formControlName="offer_url" type="url" />
  </mat-form-field>

  <mat-form-field class="full-width">
    <mat-label>Categorías de departamento</mat-label>
    <mat-select formControlName="department_category_ids" multiple>
      @for (department_category of department_categories(); track department_category.id) {
        <mat-option [value]="department_category.id">{{ department_category.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field class="full-width">
    <mat-label>Fases del pipeline</mat-label>
    <mat-select formControlName="job_vacancy_phase_types" multiple>
      @for (phase_type_option of job_vacancy_phase_type_options; track phase_type_option.value) {
        <mat-option [value]="phase_type_option.value">{{ phase_type_option.label }}</mat-option>
      }
    </mat-select>
    <mat-hint>El orden del pipeline sigue el listado estándar (Prescreening → Oferta).</mat-hint>
  </mat-form-field>

  <mat-form-field class="full-width">
    <mat-label>Fecha inicio</mat-label>
    <input matInput [matDatepicker]="start_picker" formControlName="start_date" />
    <mat-datepicker-toggle matSuffix [for]="start_picker"></mat-datepicker-toggle>
    <mat-datepicker #start_picker></mat-datepicker>
  </mat-form-field>

  <mat-form-field class="full-width">
    <mat-label>Fecha fin</mat-label>
    <input matInput [matDatepicker]="end_picker" formControlName="end_date" />
    <mat-datepicker-toggle matSuffix [for]="end_picker"></mat-datepicker-toggle>
    <mat-datepicker #end_picker></mat-datepicker>
  </mat-form-field>

  <div class="template-import-row">
    <mat-form-field class="template-import-select">
      <mat-label>Plantilla de descripción</mat-label>
      <mat-select formControlName="job_description_template_id">
        <mat-option [value]="null">Seleccionar plantilla…</mat-option>
        @for (template of job_description_templates(); track template.id) {
          <mat-option [value]="template.id">{{ template.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <button mat-stroked-button type="button" (click)="importJobDescriptionTemplate()">Importar plantilla</button>
  </div>

  <div class="editor-container">
    <label class="editor-label">Descripción del puesto</label>
    <editor
      formControlName="job_description"
      [apiKey]="tiny_mce_api_key"
      cloudChannel="6"
      id="job_description"
      [init]="tiny_mce_init"
      initialValue=""
      [inline]="false"
      tagName="div"
    ></editor>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancelar</button>
  <button mat-flat-button color="accent" type="button" [disabled]="loading() || form.invalid" (click)="save()">Guardar</button>
</mat-dialog-actions>
